import React, { useMemo } from "react";
// ANT DESIGN COMPONENTS
import { Select, Tooltip } from "antd";
// I18N TRANSLATION
import { useTranslation } from "react-i18next";
// REDUX
import { useSelector, useDispatch } from "react-redux";
import { updateFilters } from "../../../redux/reports/reportsSlice";
// CUSTOM HOOKS
import useGetAllBanksLight from "../../../customHooks/GET_requests/useGetAllBanksLight";
// INTERFACES
import { RootState } from "../../../app/store";
import { BankLightInterface } from "../../../interfaces/Bank.interface";
import { ReportSliceFiltersInterface } from "../../../interfaces/Reports.interface";

function ReportsFilterAdvanceDrawerBanks() {
  // ************************************************ */
  // GLOBAL VARIABLES ******************************* */
  const { Option } = Select;
  const dispatch = useDispatch();
  const [t] = useTranslation("global");

  // ************************************************ */
  // REDUX SLICE VARIABLES ************************** */
  const { filters } = useSelector((state: RootState) => state.report);

  // ************************************************ */
  // CUSTOM HOOKS *********************************** */
  const { banksLight } = useGetAllBanksLight(filters.organizationId);

  // ************************************************ */
  // FILTERED DATA ********************************** */
  const filteredBanks = useMemo(() => {
    if (!filters.serverId) return banksLight;
    return banksLight.filter(
      (bank: BankLightInterface) => bank.channel?.server?.id === filters.serverId,
    );
  }, [banksLight, filters.serverId]);

  // ************************************************ */
  // FUNCTIONS ************************************** */
  const onChangeBank = (newValue: string) => {
    const index = banksLight.findIndex((object: BankLightInterface) => object.id === newValue);
    const copy: ReportSliceFiltersInterface = structuredClone(filters);
    if (banksLight[index]) {
      copy.bankId = banksLight[index].id;
      copy.bankName = banksLight[index].name;
      if (banksLight[index].channel && banksLight[index].channel.server) {
        copy.serverId = banksLight[index].channel.server.id;
        copy.serverName = banksLight[index].channel.server.name;
      }
    }
    dispatch(updateFilters(copy));
  };

  // ************************************************ */
  // COMPONENT ************************************** */
  return (
    <div className="generalStyles__width100">
      <Tooltip title={filteredBanks.length === 0 ? t("report.noBanks") : ""}>
        <Select
          className="generalStyles__width100"
          disabled={filteredBanks.length === 0}
          showSearch
          optionFilterProp="children"
          placeholder={t("report.selectBank")}
          value={filters.bankId === "" ? null : filters.bankId}
          size="small"
          filterOption={(input: string, option: any) =>
            option.children.toLowerCase().includes(input.toLowerCase())
          }
          onChange={onChangeBank}
        >
          {filteredBanks.map((bank: BankLightInterface) => (
            <Option key={bank.id} value={bank.id}>
              {bank.name}
            </Option>
          ))}
        </Select>
      </Tooltip>
    </div>
  );
}

export default ReportsFilterAdvanceDrawerBanks;
